<script>
import { mapGetters } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapActions } from 'vuex';

import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';
import ModalBillExternalComponent from '@/components/debts_new/ModalBillExternalComponent.vue';
import ModalShowBillExternalDebtComponent from '@/components/bill_external/ModalShowBillExternalDebtComponent.vue';
import ModalDebtsBillComponent from '@/components/debts_bill/ModalDebtsBillComponent.vue';
import ModarServicesExtrasComponentAll from '@/components/debts/ModarServicesExtrasComponentAll.vue';
import ModalBillPayComponent from '@/components/debts_new/ModalBillPayComponent.vue';

export default {
	name: "debts-table",
	components: {
		DatePicker,
		ModalFormComponentContracts,
		ModalBillExternalComponent,
		ModalShowBillExternalDebtComponent,
		ModalDebtsBillComponent,
		ModarServicesExtrasComponentAll,
		ModalBillPayComponent
	},
	data() {
		return {
			editForm: false,
			editPay: false,
			editIncrease: false,
			load: false,
			catalogue: new Catalogue(),
			page: 1,
			range: false,
			form: {
				mail: '',
				content: '',
			},
			send: false,
			search: {
				date: '',
				department_id: '',
				building_id: '',
				company_id: '',
				user_id: '',
				payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
			},
		}
	},
	methods: {
		showBillExternalPay(contract) {
			Event.$emit("event-show-addCreateBillExternalPays", contract);
		},
		extraServices() {
			Event.$emit('event-list-extra-services-all');
		},
		showBillDebs(id) {
			Event.$emit('event-show-addCreateBillDebts', id);
		},
		showBillExternal(contract) {
			Event.$emit('event-show-bill-external-dev', contract);
		},
		isBilled(contract) {
			let item = contract.due_items;
			let itemBilled = item.filter(item => item.item_bill !== null);
			return { 'itemBilled': itemBilled.length, 'item': item.length, 'completed': item.length === itemBilled.length };
		},
		showNewContracts(contract_id) {
			Event.$emit('event-show-showContractID', contract_id);
		},
		showBill(contract) {
			Event.$emit('event-show-addCreateBillExternals', contract);
		},
		async pay(id) {
			let tit = 'Marcar como pagado';
			let txt = 'Seguro que quiere marcar como pagado';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = `/contract_dues_pay`;
					let form = {
						id: id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			search.search = this.name;
			let _endpoint = '/contract_dues';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					console.log(data);
					this.buys = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	},
	async mounted() {
		let DateBill = this.moment().format('YYYY-MM');
		this.search.date = DateBill;
		await this.catalogue.get_buildings();
		await this.catalogue.get_companies_all();
		await this.catalogue.get_users_profile(7);
		await this.list();
	},
	created() {
		Event.$on("event-load-contract_dues", () => {
			this.list();
		});
	},
	watch: {
		'search.user_id': {
			handler: function (newValue) {
				this.search.department_id = '';
				this.catalogue.get_departamens_user(newValue);
			},
			deep: true,
			immediate: true
		},
		// 'search': {
		// 	handler: function () {
		// 		this.list();
		// 	},
		// 	deep: true,
		// 	immediate: true
		// },
		'range': {
			handler: function (value) {
				if (value) {

					let monthIni = this.moment().format('YYYY-MM')
					let monthEnd = this.moment().add(1, 'M').format('YYYY-MM')
					this.search.date = [monthIni, monthEnd];

				} else {
					let month = this.moment().format('YYYY-MM')
					this.search.date = month;
				}

			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}

</script>
<template>
	<div class="col-12">
		<ModarServicesExtrasComponentAll :prop_edit="true" />
		<ModalFormComponentContracts :prop_edit="false" />
		<ModalBillExternalComponent />
		<ModalShowBillExternalDebtComponent />
		<ModalDebtsBillComponent />
		<ModalBillPayComponent />
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Lista de adeudos</h3>
				<div class="card-tools">
					<!-- <button @click="extraServices()" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa fa-plus"></i> Cargos extra
					</button> -->
					<!-- 
					<button @click="downloadDebt()" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-regular fa-file-excel ml-1 mr-1"></i> Deudas pasadas
					</button>
					<button @click="callModalMail()" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-regular fa-paper-plane"></i> PDF
					</button>
					<button @click="downloadExcel()" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-solid fa-file-excel"></i> Excel
					</button> -->
					<!-- <button @click="editBuy()" v-can="'add_contracts'" class="btn btn-sm btn-outline-info">
                        <i class="fa fa-plus"></i> Contrato
                    </button> -->
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-2">
						<label>Rango :</label>
						<input type="checkbox" v-model="range" class="form-control from-control-sm">
					</div>
					<div class="col-md-4">
						<label>Mes de reporte :</label>
						<date-picker format="YYYY-MM" :range="range" valueType="format" type="month" :clearable="false"
							v-model="search.date" @change="list"></date-picker>
					</div>
					<div class="col-md-6">
						<label>Propiedad :</label>
						<select class="form-control" v-model="search.building_id" @change="list()">
							<option value="">Todas</option>
							<option :value="building.id" v-for="(building, index) in catalogue.buildings" :key="index">
								{{ building.name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label>Cliente :</label>
						<select class="form-control" v-model="search.user_id" @change="list()">
							<option value="">Todas</option>
							<option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
								:key="user_index">{{ user.name }} {{ user.last_name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label>Empresa :</label>
						<select class="form-control" v-model="search.company_id" @change="list()">
							<option value="">Todas</option>
							<option :value="company.id" v-for="(company, index) in catalogue.companies_all"
								:key="index">{{ company.name }}</option>
						</select>
					</div>
				</div>
				<br>
				<div class="table-responsive">
					<table class="table tbl-pays table-bordered text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Datos de contrato</th>
								<th>Fecha</th>
								<th>Monto</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="6">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="buys.length > 0">
							<tr v-for="(buy, index) in buys" :key="index">
								<td class="text-center">
									{{ buy.id }}
									<br>
									<span v-if="buy.is_paid" class="badge badge-success">
										<i class="fa-solid fa-check"></i> Pagado
									</span>
								</td>
								<td>
									<div class="col-12" v-if="buy.contract.building">
										<strong>Propiedad:</strong> {{ buy.contract.building.name }}
									</div>
									<div class="col-12" v-if="buy.contract.user">
										<strong>Usuario:</strong> {{ buy.contract.user.name }} {{
											buy.contract.user.last_name }}
									</div>
									<div class="col-12" v-if="buy.contract">
										<strong>Renta unica:</strong> <span v-if="buy.unique_rent == 1">Sí</span>
										<span v-else>No</span>
									</div>
									<div class="col-12" v-if="buy.contract">
										<strong>Deposito único:</strong> <span v-if="buy.unique_deposit == 1">Sí</span>
										<span v-else>No</span>
									</div>
									<div class="col-12" v-if="buy.contract">
										<strong>Servicio único:</strong> <span v-if="buy.unique_services == 1">Sí</span>
										<span v-else>No</span>
									</div>
									<div class="col-12" v-if="buy.contract">
										<strong>Indivisos:</strong><br>
										<span class="badge p-1 badge-success ml-1"
											v-for="(department, index) in buy.contract.contract_departments"
											:key="index">
											Piso {{ department.department.level }} / {{ department.department.number }}
										</span>
										<br>
									</div>
								</td>
								<td>
									<span v-if="buy.due_date"> {{ buy.due_date | toDateTime }} </span>
								</td>
								<td v-if="buy.due_items_extras">
									<div v-for="(item, index) in buy.due_items_extras" :key="index">
										<strong>Concepto :</strong> {{ item.description }}
										<br>
										<strong>Monto :</strong> {{ item.final_amount | toCurrency }}
										<br>
										<hr v-if="index < buy.due_items_extras.length - 1">
									</div>
								</td>
								<td v-if="buy.due_items_rent_only">
									<div v-for="(item, index) in buy.due_items_rent_only" :key="index">
										<strong>Concepto :</strong> {{ item.description }}
										<br>
										<strong>Monto :</strong> {{ item.final_amount | toCurrency }}
										<br>
										<hr v-if="index < buy.due_items_rent_only.length - 1">
									</div>

								</td>
								<td>
									<button @click="showNewContracts(buy.contract_id)"
										class="btn btn-sm m-1 btn-outline-success">
										<i class="fa-solid fa-eye"></i> Ver contrato
									</button>

									
									<div class="d-inline" v-if="buy.contract_dues_bill_count == 0">
										<button @click="showBill(buy)" class="btn btn-sm m-1 btn-outline-info"
										v-if="buy.bill_external.length == 0"	
										>
											<i class="fa-solid fa-file-lines"></i> Facturar
										</button>

										<button class="btn btn-sm m-1 btn-outline-info" @click="showBillExternal(buy)"
											v-if="buy.bill_external.length > 0" >
											<i class="fa-solid fa-layer-group"></i> Ver facturas
										</button>

									</div>

									<button class="btn btn-sm m-1 btn-outline-info" @click="showBillDebs(buy.id)" v-if="buy.bill_external.length == 0">
										<i class="fa-solid fa-layer-group"></i> Facturas generadas foráneas
									</button>

									<!-- <button class="btn btn-sm m-1 btn-outline-info" @click="pay(buy.id)"
										v-if="!buy.is_paid">
										<i class="fa-solid fa-wallet"></i> Pagar
									</button> -->

									<button class="btn btn-sm m-1 btn-outline-info" @click="showBillExternalPay(buy)"
										v-if="!buy.is_paid">
										<i class="fa-solid fa-wallet"></i> Pagar
									</button>

									<div class="w-100" v-if="buy.is_paid">
										<hr>
										<label>Pagado:</label>
										{{  buy.pay_amount | toCurrency }}
									</div>

								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="6">Sin resultados.</td>
							</tr>
						</tbody>

					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<style type="text/css">
.tbl-pays {
	table-layout: fixed;
	min-width: 1000px;
	width: 100%;
}

/* tooltipn */
.tooltipn {
	position: relative;
	display: inline-block;
	border-bottom: 1px dotted black;
}

.tooltipn .tooltipntext {
	visibility: hidden;
	width: 120px;
	font-size: 12px;
	background-color: #555;
	color: #fff;
	text-align: center;
	border-radius: 6px;
	padding: 5px 2px;
	position: absolute;
	z-index: 1;
	bottom: 125%;
	left: 50%;
	margin-left: -60px;
	opacity: 0;
	transition: opacity 0.3s;
}

.tooltipn .tooltipntext::after {
	content: "";
	position: absolute;
	top: 100%;
	left: 50%;
	margin-left: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: #555 transparent transparent transparent;
}

.tooltipn:hover .tooltipntext {
	visibility: visible;
	opacity: 1;
}

.btn-show {
	position: relative;
	top: 10px;
	right: 35%;
}

.clip {
	right: 20%;
	display: inline;
	position: relative;
	cursor: pointer;
}
</style>